import { BRAND } from "~/shared/ui/theme";

// Mantido por compatibilidade com os JS antigos; a fonte da verdade é o tema (spec §5).
export const COLORS = Object.freeze({
  primary: BRAND.navy,
  accent: BRAND.cyan,
  background: BRAND.background,
  text: BRAND.text,
  muted: BRAND.muted,
});
